"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const theme_1 = require("../../theme");
const styled_components_1 = __importDefault(require("styled-components"));
const TimelineChart_1 = __importDefault(require("../custom/TimelineChart"));
const react_1 = require("react");
const lodash_1 = require("lodash");
const ship_intensity_low_png_1 = __importDefault(require("../../../images/ship-intensity-low.png"));
const ship_intensity_medium_png_1 = __importDefault(require("../../../images/ship-intensity-medium.png"));
const ship_intensity_high_png_1 = __importDefault(require("../../../images/ship-intensity-high.png"));
const ship_intensity_none_png_1 = __importDefault(require("../../../images/ship-intensity-none.png"));
const Root = styled_components_1.default.div `
  width: 100%;
  margin-bottom: ${theme_1.theme.spacing(6)};
`;
const Ships = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(auto-fill, 28px);
  gap: 2px;
  margin: ${theme_1.theme.spacing(3)} 0 ${theme_1.theme.spacing(5)} 0;
`;
const ShipImage = styled_components_1.default.img `
  transition: visibility 0s, opacity 0.5s linear;
`;
const getShipIcon = (key, intensityText) => {
    if (intensityText === undefined) {
        return ((0, jsx_runtime_1.jsx)(ShipImage, { src: ship_intensity_none_png_1.default, style: { width: 24, height: 24 } }, key));
    }
    switch (intensityText) {
        case "low":
            return ((0, jsx_runtime_1.jsx)(ShipImage, { src: ship_intensity_low_png_1.default, style: { width: 24, height: 24 } }, key));
        case "medium":
            return ((0, jsx_runtime_1.jsx)(ShipImage, { src: ship_intensity_medium_png_1.default, style: { width: 24, height: 24 } }, key));
        case "high":
            return ((0, jsx_runtime_1.jsx)(ShipImage, { src: ship_intensity_high_png_1.default, style: { width: 24, height: 24 } }, key));
    }
};
exports.default = (props) => {
    const [selectedYear, setSelectedYear] = (0, react_1.useState)();
    const getFleetMix = () => {
        if (!selectedYear) {
            return undefined;
        }
        const fleetMix = props.fuels.map((fuel, i) => {
            const fuelValue = props.data[i]?.values.find((v) => v.year === selectedYear)?.value;
            return {
                fuel,
                amount: fuelValue,
            };
        });
        if ((0, lodash_1.some)(fleetMix, (m) => m.amount === undefined)) {
            return undefined;
        }
        return fleetMix;
    };
    const getShips = () => {
        const fleetMix = getFleetMix();
        if (!fleetMix) {
            return [...Array(props.fleetSize)].map((n, i) => getShipIcon(`none-${i}`, undefined));
        }
        return (0, lodash_1.flatMap)(fleetMix, (f) => {
            return [...Array(f.amount)].map((n, i) => getShipIcon(`${f.fuel.fuel}-${i}`, f.fuel.intensity_text));
        });
    };
    return ((0, jsx_runtime_1.jsxs)(Root, { children: [(0, jsx_runtime_1.jsx)(TimelineChart_1.default, { ...props, onChange: setSelectedYear, noMargin: true }), props.fleetSize <= 40 ? (0, jsx_runtime_1.jsx)(Ships, { children: getShips() }) : undefined] }));
};
